import { CmsYoutubeProps } from '~/types/Cms';

const CmsYoutube = ({ data }: CmsYoutubeProps) => {
  const alignment = data.align || 'inherit';
  let width = Number(data.width);
  let height = Number(data.height);
  const noSize = !width && !height;
  const containerNoSizeClass = noSize ? 'ratio ratio-16x9' : '';
  const iframeNoSizeClass = noSize ? 'w-100' : '';
  if (width && !height) {
    height = (Number(width) * 9) / 16;
  }
  if (height && !width) {
    width = (Number(width) * 16) / 9;
  }
  return (
    <div className={containerNoSizeClass} style={{ textAlign: alignment }}>
      <iframe
        loading="lazy"
        className={`cms-youtube__frame ${iframeNoSizeClass}`}
        width={width}
        height={height}
        src={data.link}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default CmsYoutube;
